module.exports = __webpack_public_path__ + "img/athena-products.3ed755ec.png";